export const getNestedValue = (obj: Record<string, unknown>, path: string | string[]): unknown => {
  const pathArray = Array.isArray(path) ? path : [path];
  return pathArray.reduce((current: unknown, key: string) => {
    return (current as Record<string, unknown>)?.[key];
  }, obj);
};
